var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "upload-video-lecture" }, [
    _c("div", { staticClass: "upload-video-lecture__body container" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-12" }, [
          _c(
            "div",
            {
              staticClass:
                "upload-video-lecture__header-title typography--color-primary text-center"
            },
            [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.$t("video_lectures.upload_video.header_title")) +
                  "\n        "
              )
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "upload-video-lecture__form" }, [
            _c(
              "div",
              {
                staticClass:
                  "upload-video-lecture__upload-area mx-auto text-center"
              },
              [
                _c(
                  "label",
                  {
                    staticClass:
                      "upload-video-lecture__upload-input text-center clickable w-100"
                  },
                  [
                    _c("input", {
                      staticClass: "no-display",
                      attrs: {
                        type: "file",
                        accept: "video/mp4,video/x-m4v,video/*",
                        disabled: _vm.busy
                      },
                      on: { change: _vm.onVideoInputChange }
                    })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "upload-video-lecture__upload-text typography--headline typography--color-secondary"
                  },
                  [
                    _vm._v(
                      "\n              " +
                        _vm._s(
                          _vm.$t("video_lectures.upload_video.upload_text")
                        ) +
                        "\n            "
                    )
                  ]
                ),
                _vm._v(" "),
                _vm.busy
                  ? _c(
                      "div",
                      { staticClass: "mt-4" },
                      [
                        _c("LoadingBounce"),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "typography--body-2 typography--color-disabled pb-5"
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.$t("common.uploading")) +
                                "\n              "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ]
            )
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "upload-video-lecture__modal-area" },
      [
        _c(
          "b-modal",
          {
            staticClass: "basic-modal no-header-modal hide-cancel-btn",
            attrs: {
              id: "video-type-alert",
              "hide-header": true,
              "ok-title": _vm.$t("common.confirm")
            }
          },
          [
            _c("div", {
              domProps: {
                innerHTML: _vm._s(
                  _vm.$t("common.modal.video_type_alert.message")
                )
              }
            })
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b173b9d4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b173b9d4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/video-lectures/views/UploadVideoLecture.vue
// module id = dkNV
// module chunks = 1